// ═══ ¿QUÉ PASÓ? — EL CATÁLOGO DEL ACCIDENTE ═════════════════════════════════
//
// UNA SOLA LISTA. La necesitan dos mundos: el portal del trabajador —para pintar
// los botones del registro rápido— y el servidor —`api/aviso-accidente.js`, que
// escribe el tipo de hecho en el cuerpo del aviso al patrón—. Dos copias de esta
// lista divergirían a la tercera edición: el botón diría una cosa y el aviso otra.
//
// ⚠️ LOS RÓTULOS DESCRIBEN EL HECHO, NUNCA QUIÉN TUVO LA CULPA.
// Ni "Choqué" ni "Me chocaron". Quien registra está en la calle, recién
// accidentado, y lo que escriba ahí es lo primero que leerán el patrón, la
// aseguradora y, si llega el caso, un juez. La plataforma no le pone en la boca
// una confesión ni una acusación: le deja decir qué pasó.
//
// ⚠️ LAS CLAVES SON FIJAS. Se guardan en `accidentes/{id}.tipoEvento` y se leen
// años después. Un rótulo se puede corregir; una clave, no: cambiarla dejaría a
// todos los registros viejos con un tipo que ya no existe.
//
// `tipoEvento` NO ES LA SEPARACIÓN "VEHICULAR / NO VEHICULAR". Esa es otra
// decisión, pendiente, y no se toma aquí. Aquí solo se dice qué ocurrió.
//
// ROBO O ASALTO NO ESTÁ, A PROPÓSITO. No es un accidente: se atiende con denuncia
// y no con ajustador, y meterlo aquí ensuciaría el criterio de pendientes. Queda
// anotado como flujo propio de flotilla.
//
//   · `conVehiculo`  — se ofrece cuando hay una unidad de la empresa en el hecho.
//   · `sinVehiculo`  — se ofrece cuando el trabajador pulsó "No fue con vehículo".
//   · `hayLesionados` — el propio hecho ya dice que hay una persona lesionada, así
//     que la pregunta sobra y se guarda "Sí" sin hacerla. Preguntarle a alguien que
//     acaba de caerse "¿hay personas lesionadas?" es pedirle un toque de más.
const TIPOS_ACCIDENTE = [
  { clave: "choque_vehiculo",     rotulo: "Choque con otro vehículo",                        conVehiculo: true,  sinVehiculo: false },
  { clave: "choque_moto_bici",    rotulo: "Choque con moto o bicicleta",                     conVehiculo: true,  sinVehiculo: false },
  { clave: "golpe_fijo",          rotulo: "Golpe contra algo fijo (poste, barda u objeto)",  conVehiculo: true,  sinVehiculo: false },
  { clave: "atropello",           rotulo: "Persona atropellada",                             conVehiculo: true,  sinVehiculo: false },
  { clave: "volcadura",           rotulo: "Volcadura o salida del camino",                   conVehiculo: true,  sinVehiculo: false },
  // "SIN CHOQUE", NO "SIN VEHÍCULO". Con un viaje abierto, el aviso decía
  // "BCD-258-H · Lesión sin vehículo": la placa y el rótulo se contradecían en la
  // misma línea. Lo que distingue este hecho no es que no haya unidad —puede
  // haberla: alguien se lesiona descargando— sino que no hubo choque. La clave se
  // renombró con él cuando todavía no había ningún registro en producción que la
  // usara; a partir de aquí es fija, como las demás.
  { clave: "lesion_sin_choque",   rotulo: "Lesión sin choque (caída, golpe o corte)",        conVehiculo: true,  sinVehiculo: true, hayLesionados: true },
  { clave: "otro",                rotulo: "Otro",                                            conVehiculo: true,  sinVehiculo: true },
];

// Los botones que se ofrecen. Con vehículo, todos: alguien que trae un viaje
// abierto puede lesionarse al descargar sin que la unidad tenga nada que ver.
// Sin vehículo, solo lo que puede pasar sin vehículo.
function tiposAccidenteVisibles(conVehiculo) {
  return TIPOS_ACCIDENTE.filter((t) => (conVehiculo ? t.conVehiculo : t.sinVehiculo));
}

function tipoAccidente(clave) {
  return TIPOS_ACCIDENTE.find((t) => t.clave === clave) || null;
}

// El rótulo de una clave, o "" si no existe. Nunca inventa uno: un registro con
// una clave desconocida se queda sin rótulo, no con uno parecido.
function rotuloTipoAccidente(clave) {
  const t = tipoAccidente(clave);
  return t ? t.rotulo : "";
}

// ── Exportación en CommonJS ──────────────────────────────────────────────
// Una a una y por asignación, como `admin.js` y `push.js`: es la forma que sirve
// a la vez al navegador (webpack) y al servidor (Node) sin depender de cómo decida
// cargarlo nadie.
exports.TIPOS_ACCIDENTE = TIPOS_ACCIDENTE;
exports.tiposAccidenteVisibles = tiposAccidenteVisibles;
exports.tipoAccidente = tipoAccidente;
exports.rotuloTipoAccidente = rotuloTipoAccidente;
